import { Loader2, ArrowDown } from "lucide-react";

export default function PullIndicator({ pullY, progress, isRefreshing }) {
  const show = pullY > 0 || isRefreshing;
  if (!show) return null;
  const top = Math.max(8, pullY - 36);
  return (
    <div
      className="sm:hidden fixed left-1/2 -translate-x-1/2 z-50 pointer-events-none transition-opacity"
      style={{ top, opacity: isRefreshing ? 1 : Math.max(0.4, progress) }}
      data-testid="pull-indicator"
    >
      <div className="bg-white border border-slate-200 rounded-full h-10 w-10 grid place-items-center shadow-md">
        {isRefreshing ? (
          <Loader2 size={18} className="text-[#3E2A4E] animate-spin" />
        ) : (
          <ArrowDown
            size={18}
            className="text-[#3E2A4E] transition-transform"
            style={{ transform: `rotate(${progress * 180}deg)` }}
          />
        )}
      </div>
    </div>
  );
}
